"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHeaderEventCallbacks = createHeaderEventCallbacks;
function createHeaderEventCallbacks(contextRef) {
    return {
        community_header_link_clicked: function (source) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_header_link_clicked', {
                context: 'community',
                source: source,
            });
        },
    };
}
